import "./styles/light-theme.css";
import KingdomConnect from "./components/KingdomConnect";
import { AppSettingsProvider } from "./lib/AppSettingsContext";
import { ThemeProvider } from "./lib/ThemeContext";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <AppSettingsProvider>
      <ThemeProvider>
        <KingdomConnect />
        <Toaster />
      </ThemeProvider>
    </AppSettingsProvider>
  );
}

export default App;
